import { Dialog } from '@angular/cdk/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit, signal, ViewChild, inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonPrimaryComponent } from 'projects/components/button-primary/button-primary.component';
import { ErrorBadgeComponent } from 'projects/components/error-badge/error-badge.component';
import { PinEntryComponent } from 'projects/components/pin-entry/pin-entry.component';
import { RememberMeInfoPopup } from 'projects/login/src/app/pages/regular-login/two-factor-authentication/remember-me-info-popup/remember-me-info-popup';
import { PayErrorResponse } from 'projects/login/src/app/services/auth/models/pay-error-response';
import { REMEMBER_ME_VALUES, RememberMeValues } from 'projects/login/src/app/services/auth/models/verify-request';
import { DestroyHandlerComponent } from 'projects/components/generic/destroy-handler/destroy-handler.component';
import { TokenService } from '../../../services/auth/token.service';
import { TwoFaService } from '../../../services/auth/two-fa.service';
import { PagePopulationService } from '../../../services/page-population/page-population.service';
@Component({
  selector: 'pay-login-two-factor-authentication-page',
  imports: [ButtonPrimaryComponent, ReactiveFormsModule, TranslateModule, PinEntryComponent, ErrorBadgeComponent, FormsModule],
  templateUrl: './two-factor-authentication-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwoFactorAuthenticationPageComponent extends DestroyHandlerComponent implements OnInit, OnDestroy {
  private readonly _twoFaService = inject(TwoFaService);
  private readonly _router = inject(Router);
  private readonly _tokenService = inject(TokenService);
  private readonly _pagePopulationService = inject(PagePopulationService);
  private readonly _dialog = inject(Dialog);

  @ViewChild('pinEntryComponent') pinEntry!: PinEntryComponent;

  isSubmitting = signal(false);
  authCommunication = signal('');
  typeOfAuthentication = signal<'otp' | 'sms'>('otp');
  retryInSeconds = signal(30);
  error = signal<PayErrorResponse | undefined>(undefined);

  form = new FormGroup({
    remember: new FormControl<RememberMeValues>('never'),
  });

  ngOnInit() {
    const previousInformation = this._pagePopulationService.populationInformation;
    if (previousInformation === null) {
      this._router.navigate(['/']);
    } else {
      this.typeOfAuthentication.set(previousInformation.method);
      this.authCommunication.set(previousInformation.contactInfo);

      // this._twoFaService
      //   .getLinkToken(previousInformation.bearer, previousInformation.contactInfo)
      //   .pipe(takeUntil(this.destroy$))
      //   .subscribe({
      //     next: (token) => {
      //       // @ts-expect-error It exists!
      //       window.hsConversationsSettings = {
      //         identificationEmail: token.email,
      //         identificationToken: token.token,
      //       };
      //       // @ts-expect-error it does exist!
      //       window.HubSpotConversations?.widget?.load();
      //     },
      //   });
    }
    this.startTimer();
  }

  submit() {
    this.isSubmitting.set(true);
    const rememberChoice = this.form.controls.remember.value;
    this._twoFaService
      .verify({
        value: this.pinEntry.pinValues().join(''),
        rememberFor: rememberChoice === 'never' ? null : rememberChoice, // Set never to NULL, API does not get 'never'
      })
      .subscribe({
        next: (response) => {
          this.goodbye(response.redirectUrl);
        },
        error: (err) => {
          this.handleErrorResponse(err);
        },
      });
  }

  goodbye(redirectUrl?: string) {
    window.location.href = redirectUrl ?? window.location.protocol + '//' + window.location.host;
  }

  sendSmsAgain() {
    this._twoFaService.trigger().subscribe({
      error: (err) => {
        this.handleErrorResponse(err);
      },
    });
    this.startTimer();
  }

  returnToLogin() {
    this._router.navigateByUrl('/').then();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    // @ts-expect-error it does exist!
    window.HubSpotConversations?.widget?.remove();
  }

  private startTimer() {
    this.retryInSeconds.set(30);

    const intervalId = setInterval(() => {
      this.retryInSeconds.set(this.retryInSeconds() - 1);
      if (this.retryInSeconds() <= 0) {
        clearInterval(intervalId);
      }
    }, 1000);
  }

  private handleErrorResponse(err: HttpErrorResponse) {
    this.error.set(err.error);

    if (this.error() !== null && this.error()!.code === 'PAY-1403') {
      this._tokenService.accessToken = undefined;
      this._router.navigate(['/'], { state: { givenError: this.error() } }).then();
    }
    this.isSubmitting.set(false);
  }

  protected readonly REMEMBER_ME_VALUES = REMEMBER_ME_VALUES;

  protected selectOption(option: RememberMeValues) {
    this.form.controls.remember.setValue(option);
    this.pinEntry.focusInput(0);
  }

  protected openRememberMeInfo() {
    this._dialog.open(RememberMeInfoPopup, {
      panelClass: 'z-100',
    });
  }
}
